<template>
  <div>
  <div v-if="!nopop"
    class="cal_top"
    @click="top_click"
   >
    <div class="cal_icon"> event </div>
    <div class="cal_pop">
       <div class="cal_title">
          Add&nbsp;to&nbsp;your&nbsp;calender?
       </div>
       <div class="cal_opt">
         <b-button size="sm"
           variant="primary"
           class="cal_btn"
           @click='addTo("google")'>
           Add&nbsp;to&nbsp;Google
         </b-button>
       </div>
       <div class="cal_opt">
         <b-button size="sm"
           variant="primary"
           class="cal_btn"
           @click='addTo("outlook")'>
           Add&nbsp;to&nbsp;Outlook
         </b-button>
       </div>
       <div class="cal_opt">
         <b-button size="sm"
           variant="primary"
           class="cal_btn"
           @click='addTo("office")'>
            Add&nbsp;to&nbsp;Office
         </b-button>
       </div>
    </div>
  </div>
  
  <div v-if="nopop" class="cal_fixed_top">
    <div class="cal_fixed">
       <div class="cal_event_title">
          {{ title }}
       </div>
       <div class="cal_title">
          Add&nbsp;event&nbsp;to&nbsp;your&nbsp;calender?
       </div>
       <div class="cal_opt">
         <b-button size="sm"
           variant="primary"
           class="cal_btn"
           @click='addTo("google")'>
           Add&nbsp;to&nbsp;Google
         </b-button>
       </div>
       <div class="cal_opt">
         <b-button size="sm"
           variant="primary"
           class="cal_btn"
           @click='addTo("outlook")'>
           Add&nbsp;to&nbsp;Outlook
         </b-button>
       </div>
       <div class="cal_opt">
         <b-button size="sm"
           variant="primary"
           class="cal_btn"
           @click='addTo("office")'>
            Add&nbsp;to&nbsp;Office
         </b-button>
       </div>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: "AddToCal",
  props: ['title','startep','endep','descr','url','nopop'],
  data() {
    return  {
      popmode:"pop",
    };
  },
  mounted() {
    let vue = this;
    console.log("nopop "+vue.nopop);
    if (vue.nopop) {
      vue.popmode = "fixed";
    }
  },
  methods: {
    top_click: function(ev) {
      if (!ev || !ev.target) { return; }
      let el = ev.target.parentNode;
      let s = el.getAttribute("state");
      if (s && s == "on") {
        el.setAttribute("state","off");
      } else {
        el.setAttribute("state","on");
        setTimeout(function() {
           el.setAttribute("state","off");
        },4000);
      }
    },
    addTo: function(target) {
      let vue = this;
      console.log("Add to Calendar",target);

      let body = "";
      if (vue.descr) {
        body += "<h4> "+vue.descr+"</h4>";
      } else {
        body += "<h4> "+vue.title+"</h4>";
      }
      if (vue.url) {
        body += '<a href="'+vue.url+'">Click to Attend</a>'
      }

      //20211127T213000Z
      let isostart = (new Date(vue.startep)).toISOString();
      let isoend = (new Date(vue.endep)).toISOString();
      let isostart_min = isostart.replace(/[\-\:\.]/g,"");
      let isoend_min = isoend.replace(/[\-\:\.]/g,"");

      let url;
      if (target == "google") {
         url  = "https://calendar.google.com/calendar/render?";
         url += "action=TEMPLATE&";
         url += "dates="+isostart_min+"%2f"+isoend_min+"&";
         url += "details="+encodeURIComponent(body)+"&";
         if (vue.url) {
           url += "location="+encodeURIComponent(vue.url)+"&";
         }
         url += "text="+encodeURIComponent(vue.title);
      } else if (target == "outlook" ||
                 target == "office") {
         if (target == "outlook") {
           url  = "https://outlook.live.com/calendar/0/deeplink/compose?";
         } else {
           url  = "https://outlook.office.com/calendar/0/deeplink/compose?";
         }
         url += "body="+encodeURIComponent(body)+"&";
         url += "enddt="+encodeURIComponent(isoend)+"&";
         url += "startdt="+encodeURIComponent(isostart)+"&";
         if (vue.url) {
           url += "location="+encodeURIComponent(vue.url)+"&";
         }
         url += "subject="+encodeURIComponent(vue.title)+"&";
         url += "path=%2Fcalendar%2Faction%2Fcompose&";
         url += "rru=addevent";
      }
      if (url) {
        console.log(target+" "+url);
        window.open(url,"_blank");
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.cal_top {
  display: inline-block;
  position: relative;
  z-index:10;
  width: fit-content;
  /*padding: 0 1rem 0 0;*/
  padding: 0;
  /*border: solid 1px red;*/
  border-radius: 5px;
  line-height: 1.2;
  cursor: pointer;
}

.cal_icon {
  font-family:"Material Icons";
  color: black;
}

.cal_pop {
  display:none;
}
.cal_top:hover {
  background-color: rgba(220,200,0,20.5);
}

.cal_top[state=on] .cal_pop {
  position: absolute;
  display:block;
  border: black;
  width:auto;
  background-color:white;
  border-radius: 5px;
  border: solid black 1px;
  padding: 0.5rem;
}

@media screen and (max-width:600px) and (orientation:portrait) {
.cal_top[state=on] .cal_pop {
  position: fixed;
  top:20%;
  left:30%;
}
}

.cal_opt {
}

.cal_fixed_top {
  display: inline-block;
  position: relative;
  z-index:10;
  padding: 0;
  border-radius: 5px;
  line-height: 1.2;
  cursor: pointer;
  width: 100%;
  text-align: center;
}

.cal_fixed {
  padding: 1rem;
  max-width: 30rem;
  margin: auto;
}

.cal_title {
  font-size: 0.8rem;  
  font-color: black;
  font-weight: 600;
  padding-bottom: 0.5rem;
}

.cal_event_title {
  font-size:2.0rem;
  font-weight:500;
  text-align:left;
  color:black;
  padding-bottom: 0.5rem;
  text-transform: uppercase;
  line-height:2rem;
}

.cal_btn {
  width:100%;
  padding-top:0;
  padding-bottom:0;
}
</style>